module.exports = __webpack_public_path__ + "img/calendar.0b796047.svg";